export const SITUACAO_VALIDACAO = Object.freeze({
    VALIDANDO: 1,
    VALIDADO: 2,
    REJEITADO: 3,
});

/** Pessoa sem nenhuma situação de validação vigente (a API devolve -1). */
export const SITUACAO_VALIDACAO_NAO_VALIDADO = -1;

function idDe(pessoaOuId) {
    if (pessoaOuId == null) {
        return null;
    }
    const bruto = typeof pessoaOuId === 'object'
        ? pessoaOuId.id_situacao_validacao
        : pessoaOuId;
    const n = Number(bruto);
    return Number.isFinite(n) ? n : null;
}

/** Aceita a pessoa inteira ou só o id, porque as duas formas aparecem nas telas. */
export function isValidando(pessoaOuId) {
    return idDe(pessoaOuId) === SITUACAO_VALIDACAO.VALIDANDO;
}

export function isValidado(pessoaOuId) {
    return idDe(pessoaOuId) === SITUACAO_VALIDACAO.VALIDADO;
}

export function isRejeitado(pessoaOuId) {
    return idDe(pessoaOuId) === SITUACAO_VALIDACAO.REJEITADO;
}

export function isNaoValidado(pessoaOuId) {
    const id = idDe(pessoaOuId);
    return id === null || id === SITUACAO_VALIDACAO_NAO_VALIDADO;
}

/** Chave de i18n do rótulo da situação de validação. */
export function situacaoValidacaoLabelKey(pessoaOuId) {
    switch (idDe(pessoaOuId)) {
        case SITUACAO_VALIDACAO.VALIDANDO:
            return 'validationSituation.statusValidating';
        case SITUACAO_VALIDACAO.VALIDADO:
            return 'validationSituation.statusValidated';
        case SITUACAO_VALIDACAO.REJEITADO:
            return 'validationSituation.statusRejected';
        default:
            return 'validationSituation.notValidated';
    }
}

export default {
    SITUACAO_VALIDACAO,
    SITUACAO_VALIDACAO_NAO_VALIDADO,
    isValidando,
    isValidado,
    isRejeitado,
    isNaoValidado,
    situacaoValidacaoLabelKey,
};
